// extracted by mini-css-extract-plugin
export var deliveryRow = "_st-a";
export var fixedHeight = "_st-4";
export var freightLogo = "_st-9";
export var fullWidth = "_st-3";
export var priceColumn = "_st-5";
export var radioSelected = "_st-7";
export var radioUnselected = "_st-6";
export var selectedOption = "_st-2";
export var selectedOptionContainer = "_st-1";
export var selection = "_st-0";
export var tallSkeletonText = "_st-8";